'use strict'

define ['./quick_form.css'], () ->
  ($timeout, $scope, $rootScope, $state, $stateParams, applicationTemplate, defaultApplicationTemplate, hotkeys, RentappService, $http, RENTAPPLICATION_API_URL, ApplicationTemplate, $cacheFactory, Raven) ->
    $scope.is_editing = false
    $scope.selected = {}
    $scope.total_price = 0
    $scope.broker_emails = []
    $scope.landlord_emails = []
    $scope.submission_error = {}
    $scope.selected_account = null
    $scope.can_admin = false
    $scope.is_loading = false;
    $scope.visible_rsp_identifiers = []
    $scope.income_bundle_price = 0

    $scope.getCompany = () -> 
      $scope.is_loading = true
      $http.get "#{RENTAPPLICATION_API_URL}/api/v1/company/?with_rsp_data=true"
        .then (response) ->
          $scope.can_admin = _.some(response.data.objects.filter((comp) -> 
            return _.find(comp.memberships, { 
              can_admin: true,
              user: {
                username: $rootScope.user.username
              } }) 
          ))
          
          $scope.accounts = _.orderBy(response.data.objects[0].company_agents, ['label'])
          if $scope.is_editing
            $scope.selected_account = _.find($scope.accounts, { 
              value: $scope.applicationTemplate.landlord.username 
            })
          $scope.is_loading = false
        .catch (err) ->
          $scope.is_loading = false
    $scope.getCompany()

    $scope.applicationTemplate = applicationTemplate

    # If editing quick form
    if $stateParams.applicationTemplateSlug
      $scope.is_editing = true
      if $scope.applicationTemplate.broker_emails
        _.map($scope.applicationTemplate.broker_emails.split('\n'), (email) ->
          $scope.broker_emails.push({text: email})
        )
        
      if $scope.applicationTemplate.landlord_emails
        _.map($scope.applicationTemplate.landlord_emails.split('\n'), (email) ->
          $scope.landlord_emails.push({text: email})
        )
        
      for report_source_url in $scope.applicationTemplate.selected_report_sources
        report_source_identifier = report_source_url.match(/\/api\/v1\/reportsource\/(.*)\//)[1]
        $scope.selected[report_source_identifier] = true
        $scope.total_price = $scope.applicationTemplate.price

    # Set applicationTemplate form and selected RSPs as default template's
    # if creating new.
    unless $scope.applicationTemplate.form
      $scope.applicationTemplate.landlord = angular.copy(defaultApplicationTemplate.landlord)
      $scope.applicationTemplate.form = angular.copy(defaultApplicationTemplate.form)
      $scope.applicationTemplate.selected_report_sources = angular.copy(defaultApplicationTemplate.selected_report_sources)

      for rsp in $scope.applicationTemplate.landlord.report_source_profiles
        if rsp.active
          $scope.selected[rsp.identifier] = true
          $scope.total_price += rsp.price
    
    for rsp in $scope.applicationTemplate.landlord.report_source_profiles
      $scope.visible_rsp_identifiers.push(rsp.identifier)

      if ['mvga_employment_plus', 'argus_employment', 'mvga_identity_plus', 'mvga_income'].includes(rsp.identifier)
        $scope.income_bundle_price += rsp.price

    # Formats slug from first line of property address and strip spaces
    $scope.$watch 'applicationTemplate.property_address', (newVal, oldVal) ->
      if newVal and !$scope.is_editing 
        $scope.applicationTemplate.slug = _.capitalize(newVal).split('\n')[0].replace(/\W+/g,'')
    
    $scope.select_account = (account) ->
      $scope.selected_account = account
      $scope.set_selected_account_rsp()
    
    $scope.set_selected_account_rsp = () ->
      $scope.applicationTemplate.landlord.report_source_profiles = $scope.selected_account.report_source_profiles
      $scope.selected = {}
      $scope.total_price = 0

      for rsp in $scope.applicationTemplate.landlord.report_source_profiles
        $scope.selected[rsp.identifier] = true
        $scope.total_price += rsp.price
      
    $scope.select_rsp = (index) ->
      $scope.selected[index] = !$scope.selected[index]

      price = _.find($scope.applicationTemplate.landlord.report_source_profiles, (o) -> o.identifier == index).price

      if $scope.selected[index]
        $scope.total_price += price
      else
        $scope.total_price -= price
      
      # Income and identity rsp should be bundled
      if index == 'mvga_employment_plus'
        $scope.selected['mvga_identity_plus'] = !$scope.selected['mvga_identity_plus']

        identity_price = _.find($scope.applicationTemplate.landlord.report_source_profiles, (o) -> o.identifier == 'mvga_identity_plus').price

        if $scope.selected['mvga_identity_plus']
          $scope.total_price += identity_price
        else
          $scope.total_price -= identity_price
      
      # Income and identity rsp should be bundled
      else if index == 'argus_employment'

        for identifier in ['mvga_identity_plus', 'mvga_income']
          $scope.selected[identifier] = !$scope.selected[identifier]

          price = _.find($scope.applicationTemplate.landlord.report_source_profiles, (o) -> o.identifier == identifier).price

          if $scope.selected[identifier]
            $scope.total_price += identifier
          else
            $scope.total_price -= identifier

    $scope.submit = () ->
      if !$scope.form_slug.$valid
        $scope.error_message = true
        return

      $scope.applicationTemplate.broker_emails = (email.text for email in $scope.broker_emails).join '\n'
      $scope.applicationTemplate.landlord_emails = (email.text for email in $scope.landlord_emails).join '\n'

      $scope.submitting = true

      reports = []

      for identifier, enabled of $scope.selected
        if enabled
          reports.push(_.find($scope.applicationTemplate.landlord.report_source_profiles,{'identifier': identifier }).id.toString())

      $scope.applicationTemplate.reports = reports

      if $scope.selected_account
        $scope.applicationTemplate.account = $scope.selected_account.value

      ApplicationTemplate.quick_form(
        id: applicationTemplate.id
        $scope.applicationTemplate
      ).$promise
      .then ->
        $cacheFactory.get('$http').removeAll()

        $scope.applicationTemplate.account = $scope.selected_account
        $state.go("root.dashboard.forms", {reload: true, quick_form: $scope.applicationTemplate })
      .catch (r) ->
        $scope.error_message = true
        $scope.submission_error = r.data
        Raven.captureMessage(
          "Quickform create/edit error", 
          { 
            level: 'info', 
            extra: {
              error: r,
              is_editing: $scope.is_editing,
              slug: $scope.applicationTemplate.slug
            } 
          }
        )
        #for field, errors of r.data
        #  $scope.errors[field] = errors
      .finally ->
        $scope.submitting = false



// WEBPACK FOOTER //
// ./components/forms/quick_forms/quick_form.coffee